import { isFunction, isObject } from 'lodash';

import { datadogUtil } from './datadogRum';

let token: string | undefined;

function getToken() {
  if (token) {
    return token;
  }

  try {
    if (typeof window.localStorage !== 'undefined') {
      token = window.localStorage.getItem('token') || undefined;
    }
  } catch (error) {
    datadogUtil.addError(error);
  }

  return token;
}

function removeToken() {
  try {
    if (typeof window.localStorage === 'undefined') {
      return;
    }

    window.localStorage.removeItem('token');
    window.location.assign('/');
  } catch (error) {
    datadogUtil.addError(error);
  }
}

function getAnonymousId() {
  let anonymousId = null;

  // @ts-ignore
  if (isObject(window.analytics) && isFunction(window.analytics.user)) {
    // @ts-ignore
    const user = window.analytics.user();

    if (isFunction(user.anonymousId)) {
      anonymousId = user.anonymousId();
    }
  }

  return anonymousId;
}

export default { getToken, removeToken, getAnonymousId };
